import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import type { ReactNode } from 'react';

export function ProtectedRoute({
  children,
  role,
}: {
  children: ReactNode;
  role?: 'admin';
}) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">Cargando…</div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (role === 'admin' && user.role !== 'admin') return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
